export default {"src":"/_next/static/media/collapse.b53195f3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};